import { Yii } from "libraries/interfaces/Yii";
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IDetailsDescription, IWebSite } from 'libraries/hotel/models/details';

@Component({
    selector: 'informations',
    template: `
    <div class="informations">
        <div *ngIf="hasInformation" class="flex-1 hotel-details">
            <h3>{{ wordingContact }}</h3>

            <ng-container *ngIf="informations.address">
                <address-component [property]="informations.address | transformAddress"></address-component>
            </ng-container>

            <div *ngIf="informations.telephones" class="sep-bottom sep-top">
                <ng-container *ngFor="let telephone of informations.telephones">
                    <telephone [telephone]="telephone"></telephone>
                </ng-container>
            </div>

            <div *ngFor="let webSite of informations.sites; trackBy: trackWebSite">
                <a [attr.href]="webSite.url" target="_blank" class="link-color">{{ wordingWebSite }}</a>
            </div>
        </div>

        <ng-content></ng-content>
    </div>`,
    styleUrls: ['./informations.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationsComponent implements OnChanges {

    @Input()
    public informations: IDetailsDescription;

    public readonly wordingContact: string = Yii.t('wui-iqbh-js', 'Contact');
    public readonly wordingWebSite: string = Yii.t('wui-iqbh-js', 'Site internet');

    public hasInformation: boolean;

    public ngOnChanges(changes: SimpleChanges): void {
        this.hasInformation = Boolean(
            this.informations
            && (
                this.informations.address
                || this.informations.telephone
                || this.informations.site
            )
        );
    }

    public trackWebSite(index: number, webSite: IWebSite): string {
        return webSite.url;
    }
}
